import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import Alert from '@mui/material/Alert';
import MuiSnackbar from '@mui/material/Snackbar';

import { selectSnackbar } from '@src/store/generals/selectors';
import { setSnackbar } from '@src/store/generals/actionCreators';

import { SnackbarProps } from './Snackbar.props';
import { CircularProgress } from '@mui/material';
import { selectMenuUpdateLoader } from '@src/store/menulist/selector';


export const Snackbar: React.FC<SnackbarProps> = () => {

	const dispatch = useDispatch();
	const skbr = useSelector(selectSnackbar);

	const isFetching = useSelector(selectMenuUpdateLoader)

	const closeSnackbar = (_event?: React.SyntheticEvent | Event, reason?: string): void => {
		if (reason === 'clickaway') {
			return;
		}
		dispatch(setSnackbar({ visible: false }));
	};


	return (
		<MuiSnackbar
			key={skbr.message}
			open={isFetching || skbr.visible}
			autoHideDuration={3000}
			onClose={closeSnackbar}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>

			<Alert
				variant='filled'
				severity={isFetching  ? 'info' : skbr.status}
				icon={isFetching ? <CircularProgress size={20} /> : undefined}
				// onClose={closeSnackbar}
			>
				{isFetching ? 'Updating menu...' : skbr.message}
			</Alert>

		</MuiSnackbar>
	);
};
